import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { sessionService } from '@/core/auth/session/session.service'
import { useSession } from '@/core/auth/hooks/useSession'
import { authService } from '@/features/auth/services/auth.service'
import type { LoginResult } from '@/core/auth/session/session.types'

export function useAuth() {
  const session = useSession()
  const navigate = useNavigate()

  const login = useCallback(
    async (email: string, password: string, lang = 'es'): Promise<LoginResult> => {
      const result = await authService.login(email, password, lang)

      if (result.success) {
        sessionService.startSession(result.profile, result.expiresAtUtc, result.accessToken)
        navigate('/dashboard', { replace: true })
      }

      return result
    },
    [navigate],
  )

  const logout = useCallback(async () => {
    await authService.logout()
    sessionService.clearSession()
    navigate('/login', { replace: true })
  }, [navigate])

  return {
    ...session,
    login,
    logout,
  }
}
